<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Pendaftaran Embrio Import" >

      
     <!--  <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <div class="grow ">
                    <figure class="qrcode">
                      <vue-qrcode :value="'embrio/'+data.id" width="200"/>
                      <img class="qrcode__image" src="/images/logog.png"   alt="Chen Fengyuan"   />
                    </figure>
                  </div>
                </table>
              </div>
              <div class="grow ">
                <table >
                  <tr class="row_data">
                     <td><b>Tarikh Pendaftaran</b></td>
                     <td><b>:</b></td>
                     <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>No. Pendaftaran</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_pendaftaran}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nombor Batch</b></td>
                     <td><b>:</b></td>
                     <td>{{data.no_batch}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID Ternakan Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.id_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Pengeluar Embrio</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_pengeluar_s}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Ternakan Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baka Jantan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.baka}}</td>
                  </tr>
                  
                  <template v-if="data.jenis==2">
                  <tr class="row_data">
                     <td><b>Negara Pengeluar Embrio</b></td>
                     <td><b>:</b></td>
                     <td>{{data.negara}}</td>
                  </tr>
                  </template>
                  <template v-else>
                  <tr class="row_data">
                     <td><b>Negara</b></td>
                     <td><b>:</b></td>
                     <td>{{data.negara}}</td>
                  </tr>
                  </template>
                  <tr class="row_data">
                     <td><b>Harga Perstraw (RM)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.harga}}</td>
                  </tr>
               </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
                <table >
                  
                  <tr class="row_data">
                     <td><b>Tarikh Pengeluaran</b></td>
                     <td><b>:</b></td>
                     <td>{{$zutil.dateformat(data.tarikh_pengeluaran)}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>ID Tenarnakan Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.id_ternakan_penderma}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Ternakan Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.nama_penderma_ternakan}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baka Penderma</b></td>
                     <td><b>:</b></td>
                     <td>{{data.penderma_baka}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Bilangan Terpakai</b></td>
                     <td><b>:</b></td>
                     <td>{{data.terpakai}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Baki Straw</b></td>
                     <td><b>:</b></td>
                     <td>{{data.baki}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Gred</b></td>
                     <td><b>:</b></td>
                     <td>{{data.gred}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Stage</b></td>
                     <td><b>:</b></td>
                     <td>{{data.stage}}</td>
                  </tr>
                </table>
                
              </div>
            </div>


              <br> -->
            <!-- <w-flex class="flex justify-right" v-if="$zutil.role('1') || $zutil.role('6')">
              <w-button  bg-color="warning"  :route="$route('se.perekodan.form',id)" class="be fs-2">
                <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini 
              </w-button>
            </w-flex> -->


          <!-- </div>
        </div> -->


        <!-- <template v-if="data.jantina == 1">
        <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
          <template #item-content.1>
            <Premis :data="data" v-if="data.id > 0"/>
          </template>
          <template #item-content.2>
             <Pengambilan :data="data" v-if="data.id > 0"/>
          </template>
          <template #item-content.3>
             <FertilitiJantan :data="data" v-if="data.id > 0"/>
          </template>
        </w-tabs>
        </template>
        <template v-else>
        <w-tabs :items="tabs" :no-slider="false" active-class="primary" v-model="activeTab">
          
          <template #item-content.1>
          </template>
          <template #item-content.2>
          </template>
        </w-tabs>
        </template> -->


      <!-- </w-card> -->


       <w-card class="modern-card">
        <div class="ternakan-container">
          <div class="ternakan-left">
             <div class="grow ">
                    <figure class="qrcode">
                      <vue-qrcode :value="'se/'+data.id" width="200"/>
                      <img class="qrcode__image" src="/images/logog.png"   alt="Chen Fengyuan"   />
                    </figure>
                  </div>
          </div>

          <div class="ternakan-right">
            <ul class="info-list">
              <div class="info-columns">

               <div class="info-group">
                  <li><b>Tarikh Pendaftaran </b> : &nbsp; <span>{{ $zutil.dateformat(data.tarikh)}}</span></li>
                  <li><b>No. Pendaftaran </b> : &nbsp; <span>{{data.no_pendaftaran}}</span></li>
                  <li><b>Nombor Batch </b> : &nbsp; <span>{{data.no_batch}} </span></li>
                  <li>
                    <b>ID Ternakan Jantan</b> : &nbsp; <span>{{data.id_ternakan}} </span>
                  </li>
                  <li><b>Nama Pengeluar Embrio </b> : &nbsp; <span>{{data.nama_pengeluar_s}} </span></li>
                  <li>
                    <b>Nama Ternakan Jantan</b> : &nbsp; <span>{{data.nama_ternakan}} </span>
                  </li>

                  <li>
                    <b>Nama Ternakan Jantan</b> : &nbsp; <span>{{data.nama_ternakan}} </span>
                  </li>
                  <li>
                    <b>Baka Jantan</b> : &nbsp; <span>{{data.baka}} </span>
                  </li>
                  <template v-if="data.jenis==2">
                     <li>
                        <b>Negara Pengeluar Embrio</b> : &nbsp; <span>{{data.negara}} </span>
                     </li>
                  </template>
                  <template v-else>
                     <li>
                        <b>Negara </b> : &nbsp; <span>{{data.negara}} </span>
                     </li>
                  </template>
                  <li>
                    <b>Harga Perstraw (RM)</b> : &nbsp; <span>{{data.harga}} </span>
                  </li>
               </div>

               <div class="info-group">
                  <li><b>Tarikh Pengeluaran </b> : &nbsp; <span>{{$zutil.dateformat(data.tarikh_pengeluaran)}}</span></li>
                  <li><b>ID Tenarnakan Penderma </b> : &nbsp; <span>{{data.id_ternakan_penderma}} </span></li>
                  <li>
                    <b>Nama Ternakan Penderma </b> : &nbsp; <span>{{data.nama_penderma_ternakan}} </span>
                  </li>
                  <li><b>Baka Penderma </b> : &nbsp; <span> {{data.penderma_baka}}</span></li>
                  <li><b>Bilangan Terpakai </b> : &nbsp; <span>{{data.terpakai}} </span></li>
                  <li><b>Baki Straw </b> : &nbsp; <span>{{data.baki}} </span></li>
                  <li><b>Generasi </b> : &nbsp; <span>{{data.gred}} </span></li>
                  <li><b>Stage </b> : &nbsp; <span>{{data.stage}} </span></li>
               </div>
                
              </div>
            </ul>
          </div>
        </div>
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import VueQrcode from 'vue-qrcode'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide, VueQrcode
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'se.perekodan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Embrio Beku', route: '/embrio' },
        { label: 'Pendaftaran Embrio Import', route: '/embrio/perekodan' },
        { label: 'Papar', route: '/embrio/perekodan/'+this.id },
      ],
      data : {id : 0},
      attahecment : [],
      slides : [],
      activeTab : 0,
      tabs: [
            { title: 'Pengeluaran', content: '' },
          ]
    }
  },
  methods: {
    getData()
    {
      this.$zcomm.get(this.api_service + 'se_pendaftaran/show/'+this.id, {}).then(res => {
        this.data = res
        // this.getAttahecment()
        // this.listTabs()
      })

    },
    tutup(){
      this.$inertia.visit(window.route('embrio.perekodan.index'));
    },
    kemaskini(){
      this.$inertia.visit(window.route('embrio.perekodan.from', this.id));
    },

   
   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
<style scoped>
.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
  margin-top: -12px;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  height: 15%;
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
}




/* 🌟 Base Card */
.modern-card {
  padding: 28px;
  border-radius: 18px;
  background: linear-gradient(145deg, #ffffff, #f5f8fc);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

/* 📦 Layout: Gambar di atas, info di bawah */
.ternakan-container {
  display: flex;
  flex-direction: column; /* ⬆️ gambar di atas, info di bawah */
  align-items: center;
  gap: 24px;
}

/* 🖼️ Bagian Gambar */
.ternakan-left {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.slide-box {
  max-width: 500px;
  width: 100%;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.upload-input {
  margin-top: 18px;
  width: 100%;
  max-width: 500px;
}

/* 📎 Attachment */
.attachment-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  padding: 10px 14px;
  border-radius: 10px;
  margin-top: 10px;
  border: 1px solid #e6e9f0;
  transition: background 0.25s;
}

.attachment-list:hover {
  background: #eef3fb;
}

.file-link {
  color: #1a73e8;
  font-weight: 500;
  text-decoration: none;
}
.file-link:hover {
  text-decoration: underline;
}

.delete-btn {
  padding: 4px 8px;
  border-radius: 6px;
}

/* 📋 Info Ternakan */
.ternakan-right {
  width: 100%;
  max-width: 950px;
}

ul.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-columns {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 22px;
}

.info-group {
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.06);
  padding: 20px;
  transition: transform 0.3s ease;
}

.info-group:hover {
  transform: translateY(-3px);
}

.info-group li {
  display: flex;
  align-items: center; /* ⬅️ Rata tengah secara vertikal */
  justify-content: flex-start;
  border-bottom: 1px dashed #e0e5ec;
  padding: 6px 0;
  color: #444;
  font-size: 15px;
  line-height: 1.6;
}

.info-group li:last-child {
  border-bottom: none;
}

.info-group li b {
  color: #333;
  font-weight: 600;
  min-width: 210px;
  text-align: left;
  position: relative;
  display: flex;
  align-items: center; /* ⬅️ Rata tengah vertikal pada label juga */
}

/* Tambahkan titik dua setelah label, rata tengah */
.info-group li b::after {
/*  content: ":";*/
  margin: 0 8px; /* jarak antara label dan value */
  display: inline-block;
  text-align: center;
}

.info-group li span {
  flex: 1;
  text-align: left;
  font-weight: 500;
  color: #333;
  display: flex;
  align-items: center; /* ⬅️ Pastikan value juga rata tengah */
}


/* 📱 Responsif */
@media (max-width: 768px) {
  .info-columns {
    grid-template-columns: 1fr;
  }
  .slide-box {
    max-width: 100%;
  }
}
</style>
